import _styled from "@emotion/styled/base";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../primitives/Select/components/SingleValue/components/Container.js';
import { LabelMedium } from '../../../../primitives/Typography/index.js';
// @TODO Find out why this particular component (unlike others) does not receive `theme` in the props object
//  (which makes it impossible to override its styles via `styles` prop of the `Select` component)
const SingleValueComponent = props => {
  const {
    children,
    innerProps,
    className,
    ...restProps
  } = props;
  const {
    prefix,
    value
  } = typeof props.selectProps.formatSingleValue === 'function' ? props.selectProps.formatSingleValue({
    ...restProps
  }) : {
    prefix: null,
    value: children
  };
  return _jsxs(Container, {
    ...innerProps,
    className: className,
    highlighted: props.selectProps.highlightBehaviour === 'always',
    children: [prefix && _jsxs(_Fragment, {
      children: [_jsx(LabelMedium, {
        as: "span",
        color: "contentPrimary",
        children: prefix
      }), ' ']
    }), value]
  });
};
export const SingleValue = /*#__PURE__*/_styled(SingleValueComponent, process.env.NODE_ENV === "production" ? {
  target: "e6eq0k90"
} : {
  target: "e6eq0k90",
  label: "SingleValue"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWF3RCIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBGcmFnbWVudCBhcyBfRnJhZ21lbnQsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uLy4uL3ByaW1pdGl2ZXMvU2VsZWN0L2NvbXBvbmVudHMvU2luZ2xlVmFsdWUvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgTGFiZWxNZWRpdW0gfSBmcm9tICcuLi8uLi8uLi8uLi9wcmltaXRpdmVzL1R5cG9ncmFwaHkvaW5kZXguanMnO1xuLy8gQFRPRE8gRmluZCBvdXQgd2h5IHRoaXMgcGFydGljdWxhciBjb21wb25lbnQgKHVubGlrZSBvdGhlcnMpIGRvZXMgbm90IHJlY2VpdmUgYHRoZW1lYCBpbiB0aGUgcHJvcHMgb2JqZWN0XG4vLyAgKHdoaWNoIG1ha2VzIGl0IGltcG9zc2libGUgdG8gb3ZlcnJpZGUgaXRzIHN0eWxlcyB2aWEgYHN0eWxlc2AgcHJvcCBvZiB0aGUgYFNlbGVjdGAgY29tcG9uZW50KVxuY29uc3QgU2luZ2xlVmFsdWVDb21wb25lbnQgPSAocHJvcHMpID0+IHtcbiAgICBjb25zdCB7IGNoaWxkcmVuLCBpbm5lclByb3BzLCBjbGFzc05hbWUsIC4uLnJlc3RQcm9wcyB9ID0gcHJvcHM7XG4gICAgY29uc3QgeyBwcmVmaXgsIHZhbHVlIH0gPSB0eXBlb2YgcHJvcHMuc2VsZWN0UHJvcHMuZm9ybWF0U2luZ2xlVmFsdWUgPT09ICdmdW5jdGlvbidcbiAgICAgICAgPyBwcm9wcy5zZWxlY3RQcm9wcy5mb3JtYXRTaW5nbGVWYWx1ZSh7IC4uLnJlc3RQcm9wcyB9KVxuICAgICAgICA6IHsgcHJlZml4OiBudWxsLCB2YWx1ZTogY2hpbGRyZW4gfTtcbiAgICByZXR1cm4gKF9qc3hzKENvbnRhaW5lciwgeyAuLi5pbm5lclByb3BzLCBjbGFzc05hbWU6IGNsYXNzTmFtZSwgaGlnaGxpZ2h0ZWQ6IHByb3BzLnNlbGVjdFByb3BzLmhpZ2hsaWdodEJlaGF2aW91ciA9PT0gJ2Fsd2F5cycsIGNoaWxkcmVuOiBbcHJlZml4ICYmIChfanN4cyhfRnJhZ21lbnQsIHsgY2hpbGRyZW46IFtfanN4KExhYmVsTWVkaXVtLCB7IGFzOiBcInNwYW5cIiwgY29sb3I6IFwiY29udGVudFByaW1hcnlcIiwgY2hpbGRyZW46IHByZWZpeCB9KSwgJyAnXSB9KSksIHZhbHVlXSB9KSk7XG59O1xuZXhwb3J0IGNvbnN0IFNpbmdsZVZhbHVlID0gc3R5bGVkKFNpbmdsZVZhbHVlQ29tcG9uZW50KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPWluZGV4LmpzLm1hcCJdfQ== */");